<template>
  <loadtem v-if="proloading" :progress="progress" :point="point"></loadtem>
  <ScaleScreen :width="1920" :height="1080" class="scale-wrap" v-else>
    <div class="template">
      <mapbg ref="mapbg" class="map-bg"></mapbg>
      <div class="box-bg">
        <homehead title="企业销售数据可视化平台" class="head_animation"></homehead>
        <div class="tem-content">
          <div class="left-content">
            <textTitle title="经营情况" class="left_animation_1"></textTitle>
            <leftTop class="left_animation_1"></leftTop>
            <textTitle title="消费人群分析" class="left_animation_2"></textTitle>
            <leftCent class="left_animation_2"></leftCent>
            <textTitle title="各个省份实时销售额排行" class="left_animation_3"></textTitle>
            <leftBottom class="left_animation_3"></leftBottom>
          </div>
          <div class="center-content">
            <centerTop :vdata="{}" class="center_animation_1"></centerTop>
          </div>
          <div class="right-content">
            <textTitle title="线上线下销售额占比" class="right_animation_1"></textTitle>
            <rightTop class="right_animation_1"></rightTop>
            <textTitle title="门店销售排名" class="right_animation_2"></textTitle>
            <rightCent class="right_animation_2"></rightCent>
            <textTitle title="时段销售趋势" class="right_animation_3"></textTitle>
            <rightBottom class="right_animation_3"></rightBottom>
          </div>
        </div>
        <homebottom class="bottom_animation"></homebottom>
      </div>
    </div>
  </ScaleScreen>
</template>
  
  <script>
  import homehead from "../../components/template/temhead1.vue";
  import ScaleScreen from "../../components/scale-screen/scale-screen.vue";
  import homebottom from "../../components/template/homebottom1.vue";
  import mapbg from "../../components/scope/mapbg.vue";
  import leftTop from "../../components/template/leftTop.vue";
  import leftCent from "../../components/template/leftCent.vue";
  import leftBottom from "../../components/template/leftBottom.vue";
  import centerTop from "../../components/template/centerTop.vue";
  import rightTop from "../../components/template/rightTop.vue";
  import rightCent from "../../components/template/rightCent.vue";
  import rightBottom from "../../components/template/rightBottom.vue";
  import textTitle from "../../components/template/textTitle.vue";
  import loadtem from '../../components/porloading.vue'
  import { preloadResources } from "@/utils/loading";
  
  export default {
    components: {
      ScaleScreen,
      homehead,
      homebottom,
      mapbg,
      leftTop,
      leftCent,
      leftBottom,
      centerTop,
      rightTop,
      rightCent,
      rightBottom,
      textTitle,
      loadtem,
    },
    data() {
      return {
        titleArr: ['经营情况', '消费人群分析', '各个省份实时销售额排行', '线上线下销售额占比', '门店销售排名', '时段销售趋势'],
        proloading: true,
        point: '.',
        time1: null,
        progress: 0
      };
    },
    async created() {
      const resourceList = [
        require("@/assets/template/bg.png"),
        require("@/assets/template/bottom.png"),
        require("@/assets/template/control.png"),
        require("@/assets/template/control-left.png"),
        require("@/assets/template/control-right.png"),
        require("@/assets/template/header.png"),
        require("@/assets/template/l1-btimg.png"),
        require("@/assets/template/piebg.png"),
        require("@/assets/template/title.png"),
        require("@/assets/template/title1.png"),
      ];
      if(!this.time1) {
          this.time1 = setInterval(() => {
              this.addpoint()
          }, 600)
      }
      this.addpoint()
      await preloadResources(resourceList, this.progressCallback);
      clearInterval(this.time1)
      this.time1 = null
      this.proloading = false
    },
    methods: {
      progressCallback(progress) {
        this.progress = progress * 100
      },
      addpoint(){
          if(this.point !== '...') {
              this.point += '.'
          } else {
              this.point = ''
          }
      }
    }
  };
  </script>
<style scoped lang="scss">
.template {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  z-index: 401;

  .box-bg {
    position: relative;
    background: url('../../assets/template/bg.png') no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
    z-index: 400;
    height: 100%;
  }

  .tem-content {
    margin-top: -30px;
    height: 890px;
    width: 100%;
    display: flex;
    pointer-events: none;
  }

  .left-content,
  .right-content {
    width: 475px;
    position: relative;
    z-index: 401;
    pointer-events: auto;
  }

  .left-content {
    padding: 0 0 0 40px;
  }
  .right-content {
    padding: 0 40px 0 0;
    box-sizing: border-box;
  }

  .center-content {
    width: 980px;
    // background: #ffffff;
    position: relative;
    z-index: 401;
  }
}
</style>